/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_NachnameInputs */



/**

* @param {_Field_NachnameInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_nachname = /** @type {((inputs?: _Field_NachnameInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_NachnameInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Nachname")
});